import React from 'react';
import { StoryWrapper } from '../StoryWrapper';
import styles from '../week-reflection.module.css';

export const FlowCount = ({ story, action, isPaused, config, storyData }) => {
    return (
        <StoryWrapper storyName={storyData.component} action={action} isPaused={isPaused}>
            {storyData.data.isAfterRewards ?
                <h1 className={styles.size2}>
                    You did <b>{storyData.data.numFlowsInWeek}</b> flows total{storyData.data.numFlowsInWeek >= 5 ? '!' : ''}
                </h1>
                : <h1 className={styles.size2}>
                    You did <b>{storyData.data.numFlowsInWeek}</b> flows this week{storyData.data.numFlowsInWeek >= 5 ? '!' : ''}
                </h1>
            }
            {storyData.data.subheading && <p className={styles.margin1}>{storyData.data.subheading}</p>}
        </StoryWrapper>
    );
};